import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Socket, io } from 'socket.io-client';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private _socket?: Socket;

  constructor() {}

  createSocket(serverURL: string): void {
    if (this._socket) {
      throw new Error('socket alread created');
    }

    this._socket = io(serverURL, { withCredentials: true });
  }

  getSocket(): Socket {
    if (!this._socket) {
      throw new Error('socket not created');
    }

    return this._socket;
  }

  message(): Observable<any> {
    return new Observable((observer) => {
      const next = (data: string): void => {
        try {
          observer.next(JSON.parse(data));
        } catch {
          console.log('socket message parsing error', data);
        }
      };

      this._socket?.on('message', next);

      return () => {
        this._socket?.off('message', next);
      };
    });
  }

  /**
   * 서버/네트워크 등으로 연결이 끊길 때마다 emit.
   * @see https://socket.io/docs/v4/client-api/#event-disconnect
   */
  disconnect(): Observable<Socket.DisconnectReason> {
    return new Observable((observer) => {
      const handler = (reason: Socket.DisconnectReason): void => {
        observer.next(reason);
      };

      this._socket?.on('disconnect', handler);

      return () => {
        this._socket?.off('disconnect', handler);
      };
    });
  }

  /**
   * 끊긴 뒤 자동 재연결에 성공했을 때마다 emit (시도 번호).
   * 최초 연결 성공 시에는 발생하지 않음 — 그때는 Socket의 `connect` 이벤트 사용.
   * @see https://socket.io/docs/v4/client-api/#managerreconnect
   */
  reconnect(): Observable<number> {
    return new Observable((observer) => {
      const handler = (attempt: number): void => {
        observer.next(attempt);
      };

      this._socket?.io.on('reconnect', handler);

      return () => {
        this._socket?.io.off('reconnect', handler);
      };
    });
  }
}
